<template>
  <AppDialog :is-open="isDialogOpened"
             size="l"
             :ok-text="$t('common.delete')"
             :ok-loading="loading"
             :cancel-disabled="loading"
             data-locator="bibles-delete-dialog"
             @cancel="closeDialog"
             @ok="prepareDeleteBible"
  >
    <template #title>{{ $t('project.bibles.BibleDeleteDialog.title') }}</template>
    <template #body>
      <div> {{$t('project.bibles.BibleDeleteDialog.text1', { name: bible.name })}} </div>
      <div> {{$t('project.bibles.BibleDeleteDialog.text2')}} </div>
    </template>
  </AppDialog>
</template>

<script>
import { mapActions } from 'vuex'

import AppDialog from '@/common/dialogs/AppDialog.vue'
import { toast } from '@/common/utils/toast'
import { dialogMixin } from '@/mixins/dialogMixin'
import {BiblesActionTypes} from "@/store/modules/bibles/action_types";

export default {
  name: 'BibleDeleteDialog',
  components: { AppDialog },
  mixins: [dialogMixin],
  props: {
    bible: {
      type: Object,
      required: true,
    },
    mnemo: {
      type: String,
      required: true,
    },
  },
  data () {
    return {
      loading: false,
    }
  },
  methods: {
    ...mapActions('bibles', [BiblesActionTypes.DELETE_BIBLE, BiblesActionTypes.GET_BIBLES]),
    async prepareDeleteBible () {
      this.loading = true
      try {
        await this.DELETE_BIBLE({
          mnemo: this.mnemo,
          bibleId: this.bible.id,
        })
        toast.success(this.$t('project.bibles.BibleDeleteDialog.deleteBibleSuccess'))
        this.GET_BIBLES({ mnemo: this.mnemo })
      } catch (e) {
        toast.error(this.$t('project.bibles.BibleDeleteDialog.deleteBibleError'))
      } finally {
        this.loading = false
        this.closeDialog()
      }
    },
  },
}
</script>
